module.exports = __webpack_public_path__ + "img/wordpress.3de32fac.svg";